import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { getIcon } from "@/lib/agents";
import { toast } from "sonner";

export default function Onboarding() {
  const [tpls, setTpls] = useState([]);
  const [applying, setApplying] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/templates").then((r) => setTpls(r.data.templates)).catch(() => {});
  }, []);

  const pick = async (t) => {
    setApplying(t.id);
    try {
      await api.post(`/templates/${t.id}/apply`);
      localStorage.setItem("aios_onboarded", "1");
      toast.success(`Equipo de ${t.label} listo`);
      nav("/agents");
    } catch (e) {
      toast.error(e.response?.data?.detail || "No se pudo aplicar");
      setApplying(null);
    }
  };

  const skip = () => { localStorage.setItem("aios_onboarded", "1"); nav("/dashboard"); };

  return (
    <div className="min-h-screen bg-[var(--bg)] p-6 md:p-12" data-testid="onboarding-page">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="label-mono mb-3">BIENVENIDO</div>
          <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight mb-3">
            ¿Qué tipo de negocio tienes?
          </h1>
          <p className="text-[var(--text-dim)] max-w-xl mx-auto">
            Elige tu sector y tendrás tu equipo de agentes de IA montado al instante.
            Podrás cambiarlo o personalizarlo después.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tpls.map((t) => {
            const Icon = getIcon(t.icon);
            return (
              <button key={t.id} onClick={() => pick(t)} disabled={!!applying}
                className="text-left border border-[var(--border)] bg-[var(--surface)] p-5 hover-neon group disabled:opacity-50"
                data-testid={`onb-${t.id}`}>
                <div className="w-11 h-11 border flex items-center justify-center mb-4"
                     style={{ borderColor: t.color, color: t.color }}>
                  <Icon className="w-6 h-6" />
                </div>
                <div className="font-display font-bold text-lg mb-1 group-hover:text-[var(--accent)] transition-colors">
                  {t.label}
                </div>
                <p className="text-xs text-[var(--text-dim)] leading-relaxed line-clamp-2 mb-3">{t.description}</p>
                <div className="label-mono text-[10px]" style={{ color: applying === t.id ? "var(--accent)" : undefined }}>
                  {applying === t.id ? "aplicando…" : `${t.agents_count} agentes · elegir`}
                </div>
              </button>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <button onClick={skip}
                  className="text-sm text-[var(--text-dim)] hover:text-white underline"
                  data-testid="onb-skip">
            Ahora no — usar configuración general
          </button>
        </div>
      </div>
    </div>
  );
}
